import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "Landing",
        redirect: { name: 'Login' }

    },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import("@/views/Login"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }

    },
    {
        path: "/register",
        name: "Register",
        component: () =>
            import("@/views/Register"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }

    },
    {
        path: "/admin-tenant-register",
        name: "TenantRegister",
        component: () =>
            import("@/views/TenantRegister"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }

    },
    {
        path: "/two-factor",
        name: "TwoFactor",
        component: () =>
            import("@/views/TwoFactor"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/reset-password/:token",
        name: "ResetPassword",
        component: () =>
            import("@/views/ResetPassword"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/api/register",
        name: "AuthRegister",
        component: () =>
            import("@/views/Register"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/two-factor-confirm",
        name: "TwoFactorConfirm",
        component: () => import("@/views/TwoFactorConfirm"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        },
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("@/views/ForgotPassword"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/tenant-login",
        name: "TenantLogin",
        component: () => import("@/views/TenantLogin"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/tenant-user/workspaces",
        name: "TenantWorkspace",
        component: () => import("@/views/TenantWorkspaceIndex"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/api/email/confirm",
        name: "VerificationConfirmation",
        component: () => import("@/views/VerificationConfirmation"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    {
        path: "/email/verify",
        name: "VerificationNotice",
        component: () => import("@/views/VerificationNotice"),
        meta: {
            layout: 'AppLayoutAuth',
            public: true,
        }
    },
    // {
    //     path: "/dashboard",
    //     name: "Dashboard",
    //     component: () => import("@/views/Dashboard"),
    //     meta: {
    //         layout: 'AppLayoutDashboard',
    //         bodyBackground: '#e5e5e5',
    //     }
    // },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/views/Dashboard"),
        meta: {
            layout: 'AppLayoutDashboard'
        }
    },
    {
        path: "/workspace-dashboard",
        name: "WorkspacesDashboard",
        component: () => import("@/views/WorkspacesDashboard"),
        meta: {
            layout: 'AppLayoutDashboard',
            bodyBackground: '#e5e5e5',
        }
    },
    {
        path: '/workmaps',
        name: "WorkmapsIndex",
        component: () => import("@/views/WorkmapsIndex.vue"),
        meta: {
            layout: 'AppLayoutDashboard'
        }
    },
    {
        path: '/workmaps/:id',
        name: "WorkmapsShow",
        component: () => import("@/views/WorkmapsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard'
        }
    },
    {
        path: '/workmaps/create',
        name: "WorkmapsCreate",
        component: () => import("@/views/WorkmapsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard'
        }
    },
    {
        path: '/workmaps/:id/edit/:new?',
        name: "WorkmapsEdit",
        component: () => import("@/views/WorkmapsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
        }
    },
    {
        path: "/work-requests",
        name: "WorkRequestsIndex",
        component: () => import("@/views/WorkRequestsIndex"),
        meta: {
            layout: 'AppLayoutDashboard',
        }
    },
    {
        path: "/work-requests/create",
        name: "WorkRequestsCreate",
        component: () => import("@/views/WorkRequestsManage"),
        meta: {
            layout: 'AppLayoutDashboard',
            soon: true,
        }
    },
    {
        path: "/work-requests/:id/edit",
        name: "WorkRequestsEdit",
        component: () => import("@/views/WorkRequestsManage"),
        meta: {
            layout: 'AppLayoutDashboard',
            soon: true,
        }
    },
    {
        path: "/workmaps/:id/presentation",
        name: "WorkmapsStoryTelling",
        component: () => import("@/views/WorkmapsStoryTellingManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            soon: true,
            bodyBackground: '#e5e5e5',
        }
    },
    {
        path: "/work-requests/template",
        name: "WorkRequestsTemplate",
        component: () => import("@/views/WorkRequestsTemplate.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            soon: true,
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'ErrorNotFound',
        component: () => import("@/views/ErrorNotFound"),
        meta: {
            layout: 'AppLayoutBlank'
        }
    },
    {
        path: "/talents",
        name: "TalentsIndex",        
        component: () => import("@/views/TalentCloudsIndex.vue"),
        props: { 'currentView': 'list' },
        meta: {
            layout: 'AppLayoutDashboard',            
            bodyBackground: '#F2F2F2',            
        }
    },
    {
        path: "/talent-clouds",
        name: "TalentCloudsIndex",        
        props: { 'currentView': 'grid' },
        component: () => import("@/views/TalentCloudsIndex.vue"),
        meta: {
            layout: 'AppLayoutDashboard',            
            bodyBackground: '#F2F2F2',            
        }
    },
    {
        path: "/talents/:id",
        name: "TalentsShow",
        component: () => import("@/views/TalentManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            bodyBackground: '#F2F2F2',
            requiredRoles: ['view_talent']
        }
    },
    {
        path: "/talents/create",
        name: "TalentsCreate",
        component: () => import("@/views/TalentManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',            
            bodyBackground: '#F2F2F2',
            requiredRoles: ['create_talent']   
        }
    },
    {
        path: "/talents/:id/edit",
        name: "TalentsEdit",
        component: () => import("@/views/TalentManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',     
            bodyBackground: '#F2F2F2',
            requiredRoles: ['edit_talent', 'edit_talent_previous']
        }
    },
    {
        path: "/talent-clouds/:id",
        name: "TalentCloudsShow",
        component: () => import("@/views/TalentCloudsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            bodyBackground: '#F2F2F2',         
        }
    },
    {
        path: "/talent-clouds/create",
        name: "TalentCloudsCreate",
        component: () => import("@/views/TalentCloudsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',            
            bodyBackground: '#F2F2F2',
            requiredRoles: ['create_talent_cloud']
        }
    },
    {
        path: "/talent-clouds/:id/edit",
        name: "TalentCloudsEdit",
        component: () => import("@/views/TalentCloudsManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',     
            bodyBackground: '#F2F2F2',
        }
    },
    {
        path: "/archetypes/:id",
        name: "ArchetypesShow",
        component: () => import("@/views/ArchetypesManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            bodyBackground: '#F2F2F2',       
            requiredRoles: ['view_archetype']
        },
    },
    {
        path: "/archetypes/create",
        name: "ArchetypesCreate",
        component: () => import("@/views/ArchetypesManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',            
            bodyBackground: '#F2F2F2',
            requiredRoles: ['create_archetype']
        }
    },
    {
        path: "/archetypes/:id/edit",
        name: "ArchetypesEdit",
        component: () => import("@/views/ArchetypesManage.vue"),
        meta: {
            layout: 'AppLayoutDashboard',     
            bodyBackground: '#F2F2F2',
            requiredRoles: ['edit_archetype']
        }
    },
    {
        path: "/interactions",
        name: "InteractionsIndex",
        component: () => import("@/views/InteractionsIndex.vue"),
        meta: {
            layout: 'AppLayoutDashboard',
            requiredRoles: ['view_interaction']     
        }
    },
];

export default createRouter({
    history: createWebHistory(process.env.MIX_BASE_PATH),
    routes
});
